<full-modal-config
    modalTitle="{{ (editable.id ? l10nKeys.modalTitleEdit : l10nKeys.modalTitleNew) | vtranslate }}"
    modalSubTitle="{{ editable.getName() }}"
    [modified]="form.touched && form.dirty"
    (onCancel)="editable.dismiss(true)"
    (onSubmit)="editable.submit()"
    [busy]="editable.isBusy()"
    [errors]="editable.errors"
    [valid]="form.valid"
    class="jwt-server-profile-modal"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        #form="ngForm"
    >
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleGeneral | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleGeneral | vtranslate }}</h3>
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        fieldName="name"
                        for="name"
                        objectType="{{ editable.messageType }}"
                        required
                    >
                        {{ l10nKeys.nameInputLabel | vtranslate }}
                    </label>
                    <input
                        id="name"
                        name="name"
                        [(ngModel)]="editable.config.name"
                        clrInput
                        placeholder="{{ l10nKeys.nameInputPlaceholder | vtranslate }}"
                        regexPattern="objName"
                        required
                    />
                </avi-input-container>

                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        fieldName="issuer"
                        for="issuer"
                        objectType="{{ editable.messageType }}"
                        required
                    >
                        {{ l10nKeys.issuerInputLabel | vtranslate }}
                    </label>
                    <input
                        id="issuer"
                        name="issuer"
                        [(ngModel)]="editable.config.issuer"
                        clrInput
                        placeholder="{{ l10nKeys.issuerInputPlaceholder | vtranslate }}"
                        required
                    />
                </avi-input-container>

                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ editable.messageType }}"
                            fieldName="jwks_keys"
                            for="jwks_keys"
                            required
                        >
                            {{ l10nKeys.jwtFileInputLabel | vtranslate }}
                        </label>
                        <file-upload-textarea
                            [(ngModel)]="editable.config.jwks_keys"
                            placeholder="{{ l10nKeys.jwtFileInputPlaceholder | vtranslate }}"
                            name="jwks_keys"
                            required
                        >
                        </file-upload-textarea>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>

        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleProtectedResource | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleProtectedResource | vtranslate }}</h3>

                <avi-fieldset [hideContent]="!editable.config.protected_resource_config?.config?.enable_protected_resource_metadata">
                    <avi-fieldset_header>
                        <avi-checkbox
                            name="enable_protected_resource_metadata"
                            [(ngModel)]="editable.config.protected_resource_config?.config.enable_protected_resource_metadata"
                            objectType="JWTProtectedResourceConfig"
                            fieldName="enable_protected_resource_metadata"
                            [noMarginTop]="true"
                        >
                            {{ l10nKeys.enableProtectedResourceMetadataLabel | vtranslate }}
                        </avi-checkbox>
                    </avi-fieldset_header>

                    <avi-fieldset_content>
                        <avi-input-container>
                            <label
                                aviLabelWithTooltip
                                fieldName="metadata_url_path"
                                for="metadata-url-path"
                                objectType="JWTProtectedResourceConfig"
                                [required]="editable.config.protected_resource_config?.config?.enable_protected_resource_metadata"
                            >
                                {{ l10nKeys.metadataUrlPathLabel | vtranslate }}
                            </label>
                            <input
                                id="metadata-url-path"
                                name="metadata-url-path"
                                [(ngModel)]="editable.config.protected_resource_config?.config.metadata_url_path"
                                clrInput
                                placeholder="{{ l10nKeys.metadataUrlPathPlaceholder | vtranslate }}"
                                [required]="editable.config.protected_resource_config?.config?.enable_protected_resource_metadata"
                            />
                        </avi-input-container>

                        <div class="full-modal-config__form-control-row">
                            <div class="full-modal-config__form-control">
                                <label
                                    aviLabelWithTooltip
                                    fieldName="authorization_servers"
                                    objectType="JWTProtectedResourceConfig"
                                    for="authorization-servers"
                                >
                                    {{ l10nKeys.authorizationServersLabel | vtranslate }}
                                </label>
                                <avi-repeated-strings
                                    [(ngModel)]="editable.config.protected_resource_config?.config.authorization_servers"
                                    placeholder="{{ l10nKeys.authorizationServersPlaceholder | vtranslate }}"
                                    name="authorization-servers"
                                    id="authorization-servers"
                                    objectType="JWTProtectedResourceConfig"
                                    fieldName="authorization_servers"
                                >
                                </avi-repeated-strings>
                            </div>
                        </div>

                        <div class="full-modal-config__form-control-row">
                            <div class="full-modal-config__form-control">
                                <label
                                    aviLabelWithTooltip
                                    fieldName="supported_scopes"
                                    objectType="JWTProtectedResourceConfig"
                                    for="supported-scopes"
                                >
                                    {{ l10nKeys.supportedScopesLabel | vtranslate }}
                                </label>
                                <avi-repeated-strings
                                    id="supported-scopes"
                                    name="supported-scopes"
                                    [(ngModel)]="editable.config.protected_resource_config?.config.supported_scopes"
                                    placeholder="{{ l10nKeys.supportedScopesPlaceholder | vtranslate }}"
                                    objectType="JWTProtectedResourceConfig"
                                    fieldName="supported_scopes"
                                >
                                </avi-repeated-strings>
                            </div>
                        </div>

                        <avi-input-container>
                            <label
                                aviLabelWithTooltip
                                fieldName="resource_documentation"
                                for="resource-documentation"
                                objectType="JWTProtectedResourceConfig"
                            >
                                {{ l10nKeys.resourceDocumentationLabel | vtranslate }}
                            </label>
                            <input
                                id="resource-documentation"
                                name="resource-documentation"
                                [(ngModel)]="editable.config.protected_resource_config?.config.resource_documentation"
                                clrInput
                                placeholder="{{ l10nKeys.resourceDocumentationPlaceholder | vtranslate }}"
                            />
                        </avi-input-container>
                    </avi-fieldset_content>
                </avi-fieldset>
            </div>
        </full-modal-tab-section>
    </form>
</full-modal-config>
